module.exports = __webpack_public_path__ + "static/assets/5224ed1ba84a7a7c48a66ef30e091946.svg";